export default __webpack_public_path__ + "static/screenshot-editorial-f6180f6610c9a0f04988e81b26b1913e.png";